import styles from './ActivityCard.module.scss';

/** Colour family a count pill renders in — red for alerts, blue for connections. */
export type ActivityPillTone = 'alerts' | 'connections';

export const ACTIVITY_PILL_TONE_CLASS: Record<ActivityPillTone, string> = {
    alerts: styles.PillAlerts,
    connections: styles.PillConnections,
};
